import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListingDataSource, ListingPayload } from '@portal/shared/types/listing.types';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import { DeviceHistoryFieldName } from '../services/history-api.types';
import { HistoryDataService } from '../services/history-data.service';
import { HistoryTableData } from '../services/history-data.types';

@Injectable()
export class HistoryLogListingDataSourceService implements ListingDataSource<HistoryTableData> {
  private readonly history = inject(HistoryDataService);
  private readonly tz = inject(TimezoneService);

  total = 0;

  getAll(tableState: ListingPayload): Observable<HistoryTableData> {
    return this.history.getTableData({
      ...tableState,
      filters: [
        ...(tableState.filters ?? []).map(f => ({
          ...f,
          filteredValues:
            f.filterType === DeviceHistoryFieldName.DateTimeUtcSet
              ? this.tz.getShiftedDatepickerRangeStringified({
                  start: new Date(f.filteredValues[0]),
                  end: new Date(f.filteredValues[1])
                })
              : f.filteredValues
        }))
      ]
    });
  }
}
